export default __webpack_public_path__ + "static/media/estado-23.661cf56c.svg";